/* eslint-disable jsx-a11y/anchor-is-valid */

import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as MoreIcon } from "src/assets/static/images/moreicon.svg";
import { ReactComponent as MoreIconDarkMode } from "src/assets/static/images/more-icon-dark-mode.svg";
import { ReactComponent as UserLogo } from "src/assets/static/images/user_home.svg";
import { ReactComponent as UserLogoDarkMode } from "src/assets/static/images/user-icon-dark-mode.svg";
import actions from "src/store/common/actions";

import SidebarToggle from "./SidebarToggle";
import { Link } from "react-router-dom";
import useFormatById from "src/hooks/utils/useFormatById";
import mainActions from "src/store/profileMain/actions";
import CurrentDeviceSize from "src/hooks/utils/currentDeviceSize";
import authActions from "src/store/auth/actions";
import { ReactComponent as MainLogo } from "src/assets/static/images/mainLogo.svg";
import { ReactComponent as MainLogoEng } from "src/assets/static/images/main-logo-eng.svg";
// import { ReactComponent as MainLogoSmall } from "src/assets/static/images/mainlogosmall.svg";
// import { ReactComponent as MainLogoEng } from "src/assets/static/images/Logo_ENG 1.svg";

// import { ReactComponent as ColorSwitch } from "src/assets/static/images/color-switch.svg";
import { ReactComponent as CameraIcon } from "src/assets/static/images/cameraIco.svg";
import { ReactComponent as ArrowDown } from "src/assets/static/images/chevron-down-gray.svg";
import { ReactComponent as WhiteLogo } from "src/assets/static/images/whiteLogo.svg";

import { ReactComponent as ArrowDownDarkMode } from "src/assets/static/images/chevron-down-dark-mode.svg";

import { ReactComponent as DownArrow } from "src/assets/static/images/chevron-down (1).svg";

import MyProfileContainer from "src/containers/MyProfileContainer";
import {
  MED_HISTORY,
  PROFILE_PAGE_URL,
  PROFILE_POLICY,
  PROFILE_PROVIDERS,
  PROFILE_SERVICE_CENTER,
  PROFILE_TRAVEL,
  PROFILE_COMPENSATIONS,
  PROFILE_APPEALS,
  PROFILE_DOCTOR,
} from "src/containers/layout";

import GeoIcon from "src/assets/static/images/geoLangIcon.svg";
import EngIcon from "src/assets/static/images/icon-eng.svg";
import actionsProfileMain from "src/store/profileMain/actions";
import BiometricAuthentificationsModal from "../biometricsModals/biometricAuthentificationsModal";

export const imedil_ge = process.env.REACT_APP_IMEDIL_LINK;

const Topbar = () => {
  const dispatch = useDispatch();
  const currentDeviceSize = CurrentDeviceSize();
  const [openSideBar, setOpenSideBar] = useState(false);
  const f = useFormatById();
  const lang = useSelector((state) => state.common.lang);
  const biometricSetup = useSelector((state) => state.auth.biometricSetup);
  const [showProducts, setShowProducts] = useState(false);
  const [showOrders, setShowOrders] = useState(false);
  const [showInsuranceProducts, setShowInsuranceProducts] = useState(false);
  const [showLang, setShowLang] = useState(false);

  const [openHealthDropdown, setOpenHealthDropdown] = useState(false);
  const [openCitizenshipDropdown, setopenCitizenshipDropdown] = useState(false);

  const dropdown1Ref = useRef(null);
  const dropdown2Ref = useRef(null);
  const dropdown3Ref = useRef(null);
  const dropdown4Ref = useRef(null);
  const sideBarClose = useRef(null);
  const mainPersonalInfo = useSelector(
    (state) => state.profileMain.mainPersonalInfo
  );
  const openUserModal = useSelector((state) => state.profileMain.openUserModal);
  let [lastStoredValue, setLastStoredValue] = useState(
    localStorage.getItem("ImageHasUpdated")
  );

  useEffect(() => {
    const checkLocalStorage = () => {
      const storedValue = localStorage.getItem("ImageHasUpdated");
      if (storedValue !== lastStoredValue) setLastStoredValue(storedValue);
    };

    const intervalId = setInterval(checkLocalStorage, 100);

    return () => {
      clearInterval(intervalId);
    };
  }, [lastStoredValue]);

  useEffect(() => {
    dispatch(actionsProfileMain.getPersonalInfo());
    dispatch(actionsProfileMain.getShowSpecialistPopup());
  }, [dispatch, lang, lastStoredValue]);

  useEffect(() => {
    localStorage.setItem("isUnderAge", mainPersonalInfo?.isUnderage);
  }, [mainPersonalInfo]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdown1Ref.current &&
        !dropdown1Ref.current.contains(event.target)
      ) {
        setShowProducts(false);
      }
      if (
        dropdown2Ref.current &&
        !dropdown2Ref.current.contains(event.target)
      ) {
        setShowOrders(false);
      }

      if (
        dropdown3Ref.current &&
        !dropdown3Ref.current.contains(event.target)
      ) {
        setShowLang(false);
      }
      if (
        dropdown4Ref.current &&
        !dropdown4Ref.current.contains(event.target)
      ) {
        setShowInsuranceProducts(false);
      }

      if (
        sideBarClose.current &&
        !sideBarClose.current.contains(event.target)
      ) {
        setOpenSideBar(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!showProducts) {
      setOpenHealthDropdown(false);
      setopenCitizenshipDropdown(false);
    }
  }, [showProducts]);

  const openRightDropdowns = (isHealth) => {
    if (openCitizenshipDropdown && !openHealthDropdown && isHealth) {
      setOpenHealthDropdown(true);
      setopenCitizenshipDropdown(false);
    }
    if (openHealthDropdown && !openCitizenshipDropdown && !isHealth) {
      setOpenHealthDropdown(false);
      setopenCitizenshipDropdown(true);
    }
  };

  const [dropdownHeight, setDropdownHeight] = useState("auto"); // Initialize the height as 'auto'
  const dropdownRef = useRef(null);

  useEffect(() => {
    // Calculate the height of the dropdown-content div and set it in the state
    if (dropdownRef.current) {
      const height = dropdownRef.current.clientHeight;
      setDropdownHeight(`${height}px`);
    }
  }, [showProducts, openHealthDropdown, openCitizenshipDropdown]); // You may need to adjust the dependencies

  const handleDarkMode = () => {
    dispatch(actions.setApplicationDarkMode(!darkMode));
  };

  const darkMode = useSelector((state) => state.common.darkMode);
  const profileContainerRef = useRef(null);
  const profileContainerRef1 = useRef(null);
  const profileContainerRef3 = useRef(null);
  const profileContainerRef4 = useRef(null);

  const handleClickOutside = (event) => {
    if (
      (profileContainerRef?.current &&
        !profileContainerRef?.current.contains(event.target) &&
        profileContainerRef3?.current &&
        !profileContainerRef3?.current.contains(event.target)) ||
      (profileContainerRef1?.current &&
        !profileContainerRef1?.current.contains(event.target) &&
        profileContainerRef4?.current &&
        !profileContainerRef4?.current.contains(event.target))
    ) {
      dispatch(mainActions.setOpenUserModal(false));
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const profilePictureRef = useRef();

  const [profilePicture, setProfilePicture] = useState(undefined);

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      setProfilePicture(reader.result);
    };
    if (file) reader.readAsDataURL(file);
  };
  useEffect(() => {
    if (openUserModal === false) {
      dispatch(mainActions.setCheckChild(false));
    }
  }, [openUserModal]);
  const handleHideBiometricsAuthModal = () => {
    dispatch(
      authActions.getBiometricLoginStatus({
        userName: mainPersonalInfo?.personalId,
      })
    );
    dispatch(authActions.setShowBiometricsModal(false));

    dispatch(
      authActions.setBiometricSetup({
        success: undefined,
        credentialId: null,
      })
    );
  };
  const handleActivate = () => {
    dispatch(authActions.setShowBiometricsModal(false));
    dispatch(
      authActions.getBiometricSetup({
        username: mainPersonalInfo?.personalId,
      })
    );
  };
  useEffect(() => {
    if (biometricSetup?.success !== undefined) {
      dispatch(authActions.setShowBiometricsModal(false));
    }
  }, [biometricSetup]);

  return (
    <>
      <BiometricAuthentificationsModal
        showBiometricsAuthModal={biometricSetup?.success !== undefined}
        handleHideBiometricsAuthModal={handleHideBiometricsAuthModal}
        isSuccess={biometricSetup?.success === true}
        isRetry={biometricSetup?.success === false}
        handleActivate={handleActivate}
      />
      <div className={"header my-auto" + (darkMode ? " dark-mode" : "")}>
        <div className="d-md-none my-auto ms-5" style={{ cursor: "pointer" }}>
          {darkMode ? (
            <MoreIconDarkMode onClick={() => setOpenSideBar(true)} />
          ) : (
            <MoreIcon onClick={() => setOpenSideBar(true)} />
          )}
        </div>
        <>
          <div className="container-fluid">
            <div className="row d-flex align-items-center mt-2">
              <div className="col-md-4 col-sm-6 text-center mt-md-2 pt-md-0 pt-sm-3 pt-4 ps-sm-5 header-logo">
                <Link to={PROFILE_PAGE_URL}>
                  {lang === "en" ? (
                    <MainLogoEng
                      className="mx-auto main-logo"
                      width={"186px"}
                      height={"50"}
                    />
                  ) : darkMode ? (
                    <WhiteLogo
                      className="mx-auto main-logo"
                      width={"186px"}
                      height={"50"}
                    />
                  ) : (
                    <MainLogo
                      className="main-logo"
                      width={"186px"}
                      height={"40"}
                    />
                  )}
                </Link>
              </div>
              <div
                className="col-md-8 col-6 d-md-block d-none text-end pe-5 header-profile"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                {/* <ColorSwitch
                  className="me-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDarkMode()}
                /> */}

                <div
                  ref={profileContainerRef3}
                  className="my-profile"
                  style={{ float: "right", color: darkMode ? "#fff" : "" }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <>
                      {!mainPersonalInfo?.avatar && (
                        <CameraIcon
                          className="me-2"
                          // style={{ cursor: "pointer" }}
                          // onClick={() => profilePictureRef.current.click()}
                        />
                      )}
                      <div>
                        <input
                          type="file"
                          accept=".png,.jpg,jpeg"
                          ref={profilePictureRef}
                          style={{ display: "none" }}
                          onChange={handleFileInputChange}
                        />
                      </div>
                    </>

                    {mainPersonalInfo?.avatar && (
                      <img
                        src={mainPersonalInfo?.avatar}
                        className="profile-pic-style me-2"
                        alt=""
                        width={"100%"}
                        // onClick={() => profilePictureRef.current.click()}
                      />
                    )}

                    <span
                      onClick={() =>
                        dispatch(mainActions.setOpenUserModal(!openUserModal))
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {f("myProfile.myProfile")}
                      {darkMode ? <ArrowDownDarkMode /> : <ArrowDown />}
                    </span>
                  </div>

                  {openUserModal && currentDeviceSize === "Desktop" && (
                    <div ref={profileContainerRef}>
                      <MyProfileContainer />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="d-block d-md-none">
                {openUserModal && currentDeviceSize === "Mobile" && (
                  <div ref={profileContainerRef1}>
                    <MyProfileContainer />
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
        {/* <div className="my-auto d-none d-md-block ms-sm-auto">
          <a href={imedil_ge + "Auth/ElectronicPolicy"} className="el-policy-text me-5" rel="noreferrer"><UserLogo className="me-2" />{f("topbar.myPolicy")}</a>
        </div> */}
        <div className="my-auto d-md-none d-block" ref={profileContainerRef4}>
          <a
            className="el-policy-text me-5"
            style={{ cursor: "pointer" }}
            rel="noreferrer"
            onClick={() =>
              dispatch(mainActions.setOpenUserModal(!openUserModal))
            }
          >
            {darkMode ? (
              <UserLogoDarkMode className="small-person-icon" />
            ) : (
              <UserLogo className="small-person-icon" />
            )}
          </a>
        </div>
      </div>
      <nav className="navbar navbar-expand-md navbar-light bg-light d-none d-md-block">
        <div className="container-fluid">
          <div
            className="collapse navbar-collapse justify-content-center"
            id="navbarNavDropdown"
          >
            <ul className="navbar-nav d-flex justify-content-between align-items-center">
              {/* <li className="nav-item my-auto">
                <Link className="nav-link active" aria-current="page" to={"/"}>{f('sidebar.mainPage')}</Link>
              </li> */}
              <li className="nav-item my-auto" ref={dropdown1Ref}>
                <div className="dropdown">
                  <button
                    className="dropbtn"
                    onClick={() => setShowProducts((item) => !item)}
                  >
                    {f("myProfile.myIncurence")}
                    <DownArrow className="ms-3" />
                  </button>
                  {showProducts && (
                    <>
                      <div className="dropdown-container">
                        <div className="dropdown-content" ref={dropdownRef}>
                          <Link
                            to={PROFILE_POLICY}
                            onClick={() => setShowProducts(false)}
                          >
                            {f("myProfile.myPolicies")}
                          </Link>
                          <Link
                            to={MED_HISTORY}
                            onClick={() => setShowProducts(false)}
                          >
                            {f("myProfile.myMedHistory")}
                          </Link>
                          <Link
                            to={PROFILE_PROVIDERS}
                            onClick={() => setShowProducts(false)}
                          >
                            {f("myProfile.myProvClinics")}
                          </Link>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </li>
              <li className="nav-item my-auto">
                <Link className="nav-link" to={PROFILE_DOCTOR}>
                  {f("myProfile.appointmentDoctor")}
                </Link>
              </li>
              <li className="nav-item my-auto" ref={dropdown2Ref}>
                <div className="dropdown">
                  <button
                    className="dropbtn"
                    onClick={() => setShowOrders((item) => !item)}
                  >
                    {f("myProfile.remoteServices")}
                    <DownArrow className="ms-3" />
                  </button>
                  {showOrders && (
                    <div className="dropdown-content">
                      <Link
                        to={"/" + PROFILE_APPEALS}
                        onClick={() => setShowOrders(false)}
                      >
                        {f("breadCrumb.appeals")}
                      </Link>
                      {/* temporary addition */}
                      {/* <a
                        href="https://claims.imedil.ge/"
                        target="_ blank"
                        onClick={() => setShowOrders(false)}
                      >
                        {f("breadCrumb.appeals")}
                      </a>
                      <a
                        href="https://guarantee.imedil.ge/"
                        target="_ blank"
                        onClick={() => setShowOrders(false)}
                      >
                        {f("breadCrumb.hospitalGuarantee")}
                      </a> */}
                      <Link
                        to={PROFILE_COMPENSATIONS}
                        onClick={() => setShowOrders(false)}
                      >
                        {f("breadCrumb.compensations")}
                      </Link>
                      <Link
                        to={PROFILE_SERVICE_CENTER}
                        onClick={() => setShowOrders(false)}
                      >
                        {f("myProfile.bookingServiceCenter")}
                      </Link>
                    </div>
                  )}
                </div>
              </li>
              <li className="nav-item my-auto" ref={dropdown4Ref}>
                <div className="dropdown">
                  <button
                    className="dropbtn"
                    onClick={() => setShowInsuranceProducts((item) => !item)}
                  >
                    {f("myProfile.insuranceProducts")}
                    <DownArrow className="ms-3" />
                  </button>
                  {showInsuranceProducts && (
                    <div className="dropdown-content">
                      <Link
                        className="nav-link"
                        to={PROFILE_TRAVEL}
                        onClick={() => setShowInsuranceProducts(false)}
                      >
                        {f("myProfile.travelInsurance")}
                      </Link>
                    </div>
                  )}
                </div>
              </li>
            </ul>
          </div>
          <div className="dropdown me-3" ref={dropdown3Ref}>
            <button
              className="dropbtn"
              onClick={() => setShowLang((item) => !item)}
            >
              <img
                src={lang !== "ge" ? EngIcon : GeoIcon}
                alt=""
                className="pe-2"
              />
              {lang === "ge" ? "ქარ" : "Eng"}
              <DownArrow className="ms-3" />
            </button>
            {showLang && (
              <div
                className="dropdown-content"
                style={{ minWidth: "130px", marginRight: "-4px" }}
              >
                <a
                  className="text-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowLang(false);
                    dispatch(actions.setLanguage(lang === "ge" ? "en" : "ge"));
                    localStorage.setItem("lang", lang === "ge" ? "en" : "ge");
                  }}
                >
                  <img
                    src={lang === "ge" ? EngIcon : GeoIcon}
                    alt=""
                    className="pe-2"
                  />
                  {lang !== "ge" ? "ქარ" : "Eng"}
                </a>
              </div>
            )}
          </div>
        </div>
      </nav>
      {openSideBar && (
        <div>
          <SidebarToggle
            setOpenSideBar={setOpenSideBar}
            sideBarClose={sideBarClose}
          />
        </div>
      )}
    </>
  );
};

export default Topbar;
